import {cookieManager} from "@/service/cookieManager";

const state = {
	button: {
		defaultBorder: "welcom",
	},

	commanderProducts: {
		listProducts: true,
	},

	showDelivery: false,
	showUberEats: false,
	showJustEat: false,
	showGlovo: false,
	showTakeaway: true,
};

const getters = {
	buttonBorder: (state) => state.button.defaultBorder,
	listProducts: (state, getters, rootState) => {
		const copilotConfig = rootState.venue?.copilotConfig;
		if (copilotConfig?.copilotCommanderStyle === "grid") return false;
		if (copilotConfig?.copilotCommanderStyle === "list") return true;
		return state.commanderProducts.listProducts;
	},
	showDelivery: (state) => state.showDelivery,
	showUberEats: (state) => state.showUberEats,
	showJustEat: (state) => state.showJustEat,
	showGlovo: (state) => state.showGlovo,
	showTakeaway: (state) => state.showTakeaway,
};

const mutations = {
	setListProducts(state, value) {
		state.commanderProducts.listProducts = value;
	},
};

const actions = {
	initializeListProductsFromCookie({commit}) {
		const cookieValue = cookieManager.getCookie("commanderStyle");
		if (cookieValue) {
			try {
				const parsed = JSON.parse(cookieValue);
				if (typeof parsed.listProducts === "boolean") {
					commit("setListProducts", parsed.listProducts);
				}
			} catch (e) {
				console.error("Error parsing commanderStyle cookie:", e);
			}
		}
	},

	updateListProducts({commit, dispatch}, value) {
		commit("setListProducts", value);
		dispatch("saveViewOptionsToCookie");
	},

	saveViewOptionsToCookie({state}) {
		cookieManager.setCookie("commanderStyle", JSON.stringify(state.commanderProducts));
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
